import { PageheaderListUrlSortField } from "@saleor/pageheaders/urls";
import { PageHeaderSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: PageheaderListUrlSortField
): PageHeaderSortField {
  switch (sort) {
    case PageheaderListUrlSortField.id:
      return PageHeaderSortField.ID;
    case PageheaderListUrlSortField.name:
      return PageHeaderSortField.NAME;
    case PageheaderListUrlSortField.created:
      return PageHeaderSortField.CREATION_DATE;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
